<template>
  <div class="covid-card-container w3-card w3-padding w3-margin-top">
    <h4>COVID-19 კვლევა</h4>
    <button @click="printTest">Print</button>
    <button @click="goToEdot">Edit</button>
    <p>პაციენტის ID: {{test_json.patient_id}}</p>
    <p>შედეგი: {{test_json.covid_data.testResult}}</p>
  </div>
</template>

<script>
export default {
  name: "CovidTestCard",
  props: ["test_json"],
  methods: {
    printTest() {
      console.log('now should print test')
      // this.$router.push({
      //   name: 'testMock',
      //   params: {'testId': this.test_json.test_id},
      // })
      const routeData = this.$router.resolve({
        name: 'testMock',
        params: {'testId': this.test_json.test_id},
      })
      window.open(routeData.href, '_blank');
    },
    goToEdot() {
      console.log('goToEdit test:', this.test_json.test_id, ' patient: ', this.test_json.patient_id)
      this.$router.push({
        name: 'registerCovid',
        params: { patientId: this.test_json.patient_id },
        query: { testId: this.test_json.test_id },
      })
    }
  }
}
</script>

<style>

</style>